import { render, staticRenderFns } from "./moreCopyDialog.vue?vue&type=template&id=9ea13268&scoped=true&"
import script from "./moreCopyDialog.vue?vue&type=script&lang=js&"
export * from "./moreCopyDialog.vue?vue&type=script&lang=js&"
import style0 from "./moreCopyDialog.vue?vue&type=style&index=0&id=9ea13268&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea13268",
  null
  
)

export default component.exports